import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { format } from 'date-fns';

import { useSupplierDetailsContext } from '@/modules/suppliers/supplier-details/context';
import { formatCurrencyInBDT } from '@/utils';

export const SupplierSummary = () => {
    const { data } = useSupplierDetailsContext();

    const totalOrders = data?.data?.total_purchases || 0;
    const averagePurchaseValue = data?.data?.average_purchase_value || 0;
    const lastPurchaseDate = data?.data?.last_purchase_date
        ? format(data?.data?.last_purchase_date, 'PPP')
        : 'N/A';
    return (
        <Card>
            <CardHeader className="p-4 sm:p-6">
                <CardTitle>Supplier Summary</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 p-4 pt-0 sm:p-6 sm:pt-0">
                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Total Orders</span>
                    <span className="break-words font-medium">
                        {totalOrders}
                    </span>
                </div>

                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Average Spending</span>
                    <span className="break-words font-medium">
                        {formatCurrencyInBDT(averagePurchaseValue)}
                    </span>
                </div>

                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Last Purchase</span>
                    <span className="break-words font-medium">
                        {lastPurchaseDate}
                    </span>
                </div>
            </CardContent>
        </Card>
    );
};

SupplierSummary.displayName = 'SupplierSummary';
